// @ts-strict-ignore
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { Item, ItemDesc, StyledRadio, StyledRadioGroup } from '../../theme/styles';

const Reactions = ({ name }: { name: string }) => {
  const { values, setFieldValue } = useFormikContext<{ [key: string]: string }>();

  const handleChange = (e: string) => {
    setFieldValue(name, e);
  };

  const isSelected = (value: string) => values[name] === value;

  const reactions = [
    {
      value: 'upset',
      emoji: '😠'
    },
    {
      value: 'disappointed',
      emoji: '🙁'
    },
    {
      value: 'confused',
      emoji: '😕'
    },
    {
      value: 'good',
      emoji: '🙂'
    },
    {
      value: 'happy',
      emoji: '😀'
    }
  ];

  return (
    <StyledRadioGroup labelledBy="reaction" onChange={handleChange} value={values[name]}>
      {reactions.map(reaction => (
        <StyledRadio value={reaction.value} key={reaction.value}>
          <Item className={classNames({ selected: isSelected(reaction.value) })}>
            {reaction.emoji}
          </Item>
          <ItemDesc className={classNames({ selected: isSelected(reaction.value) })}>
            {reaction.value}
          </ItemDesc>
        </StyledRadio>
      ))}
    </StyledRadioGroup>
  );
};

export default Reactions;
